<div class="text-input" [ngClass]="{ error: control.errors && (control.dirty || control.touched), disabled: control.disabled }">
  @if (label && label.length) {
    <label class="heavy-label">{{ label }}</label>
  }
  <input
    class="text"
    name="text-input"
    [type]="type"
    [placeholder]="placeholder || ''"
    [formControl]="control"
    [attr.disabled]="control.disabled ? true : null"
    [maxlength]="maxlength"
    />
  <span class="bar"></span>
</div>
